module.exports = __webpack_public_path__ + "static/media/Michael M. Larsen@2x.738b0454.jpg";